import { Typography } from "@mui/material";

export default function TextFieldLabel(props) {
    return (
        <Typography variant="label" component="label" variantMapping={{ label: 'body1' }} sx={{ marginRight: 1, marginBottom: 0.5, padding: '6px 10px' }}>
            {props.text}
        </Typography>
    )
}